export default class AP {
  mac?: string
  name?: string
  rssiThreshold?: number
  stayThreshold?: number
  congestionBorder1?: number
  congestionBorder2?: number

  constructor(attrs = {}) {
    Object.assign(this, attrs)
  }
}